import { calculateDealPrice } from '@oneecosystem/dealshaker-core';

export const onGoingChatResponse = res => ({
  ...res,
  dealDetails: res.dealDetail ? calculateDealPrice(res.dealDetail) : res.dealDetail,
});
